import AddressView from './AddressView'

export default AddressView
